import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppAuthMode } from '@features/authentication/types/AppAuthMode';
import { User } from '@project-types/User';
import { store } from '@store/store';



interface AuthState {
	user: User | null,
	appAuthMode: AppAuthMode,
};

const initialState: AuthState = {
	user: null,
	appAuthMode: AppAuthMode.authStart,
};



export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setUser: (state, action: PayloadAction<User | null>) => {
			state.user = action.payload;
		},
		setAppAuthMode: (state, action: PayloadAction<AppAuthMode>) => {
			state.appAuthMode = action.payload;
		},
	},
});



export const { setUser, setAppAuthMode } = authSlice.actions;



export const plainSetAppAuthMode = (appMode: AppAuthMode) => store.dispatch(setAppAuthMode(appMode));